<ng-container [ngTemplateOutlet]="template"> </ng-container>

<ng-template #template let-tagGroups="tagGroups">
  <form [formGroup]="formGroup">
    <div flexLayout="row wrap" flexLayoutAlign="start center" flexLayoutGap="1rem">
      @for (childType of tagTypes; let i = $index; track i) {
        @if (i === 0) {
          <mat-form-field flex appearance="fill" class="custom-selector-field">
            <mat-label>{{ tagTypes[0] | tagTypeDisplayName | async }}</mat-label>
            <mat-select
              panelClass="custom-select-panel"
              [formControl]="formControls[tagTypes[0]]"
              multiple
              (selectionChange)="onTagChanged($event.value, tagTypes[0])"
            >
              @for (tagGroup of getParentGroup(childType); track tagGroup.tag.tagId) {
                <mat-option [value]="tagGroup.tag.tagId">
                  {{ tagGroup.tag.displayName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (i > 0) {
          <mat-form-field flex appearance="fill" class="custom-selector-field">
            <mat-label>{{ childType | tagTypeDisplayName | async }}</mat-label>
            <mat-select
              panelClass="custom-select-panel"
              [formControl]="formControls[childType]"
              multiple
              (selectionChange)="onTagChanged($event.value, childType)"
            >
              @for (tagGroup of getSelectedGrouping(childType); track tagGroup.tag.tagId) {
                <mat-optgroup [label]="tagGroup.tag.displayName">
                  @for (
                    childTagGroup of getChildrenOfType(tagGroup.children, childType);
                    track childTagGroup.tag.tagId
                  ) {
                    <mat-option [value]="childTagGroup.tag.tagId">
                      {{ childTagGroup.tag.displayName }}
                    </mat-option>
                  }
                </mat-optgroup>
                <mat-divider></mat-divider>
              }
            </mat-select>
          </mat-form-field>
        }
      }
    </div>
  </form>
</ng-template>
